import React from 'react';
import { Heading2, Subtitle } from '../Typography';
import AnimatedSection from '../AnimatedSection';

interface SectionProps {
  title?: string;
  titleStyle?: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  backgroundImage?: string;
  backgroundPosition?: string;
  backgroundColor?: string;
  animationType?: 'fade' | 'slide' | 'zoom' | 'bounce';
  animate?: boolean;
}

const Section: React.FC<SectionProps> = ({
  title,
  titleStyle,
  subtitle,
  children,
  className,
  containerClassName,
  backgroundImage,
  backgroundPosition,
  backgroundColor,
  animationType = 'slide',
  animate = false,
}) => {
  const style = {
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
    backgroundPosition: backgroundPosition || 'bottom',
    backgroundColor: backgroundColor || '#CEC7C1',
  };
  const classNames = className
    ? `px-2 py-12 md:px-14 md:py-24 ${className}`
    : 'px-2 py-12 md:px-14 md:py-24';

  const containerclassNames = containerClassName
    ? `container mx-auto px-4 ${containerClassName}`
    : `container mx-auto px-4`;

  return (
    <AnimatedSection animationType={animationType} animate={animate}>
      <section className={classNames} style={style}>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        {title && <Heading2 className={titleStyle}>{title}</Heading2>}
        <div className={containerclassNames}>{children}</div>
      </section>
    </AnimatedSection>
  );
};

export default Section;
